import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const COMPANY_ACCOUNT_SCHEMA = Object.freeze({
  ACCOUNT_ID: '',
  COMPANY_NAME: '',
  EXPIRY_DATE_UTC: '',
  FORMATTED_EXPIRY_DATE: '',
  IS_EXPIRED: false,
  PLAN_NAME: '',
  PLAN_UUID: '',
  RANGE: 0,
  VERSION: 0,
});

const RECORD = generateSchema(COMPANY_ACCOUNT_SCHEMA);
const KEYS: any = generateKeys(COMPANY_ACCOUNT_SCHEMA);

export class CompanyAccount extends Record(RECORD) {
  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});
    super(props);
  }

  get accountId(): string {
    return this.get(KEYS.ACCOUNT_ID);
  }

  get companyName(): string {
    return this.get(KEYS.COMPANY_NAME);
  }
}
